import script from "./SectionViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./SectionViewer.vue?vue&type=script&setup=true&lang=js"

import "./SectionViewer.vue?vue&type=style&index=0&id=121d229e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-121d229e"]])

export default __exports__